import { cva } from 'class-variance-authority';
import { forwardRef } from 'react';
import { classNames } from '~/utils/styles';
import type { ChipProps } from './Chip.types';

export const Chip = forwardRef<HTMLSpanElement, ChipProps>(
  ({ className, size = 'medium', appearance = 'default', children, ...props }, ref) => {
    const variants = cva('w-auto rounded-full whitespace-nowrap', {
      variants: {
        appearance: {
          danger: 'bg-red-100 text-red-700',
          darker: 'bg-neutral-200 text-neutral-900',
          default: 'bg-neutral-100 text-neutral-1000',
          ghost: 'border border-neutral-500 bg-transparent text-neutral-800',
          info: 'bg-gradient-100/10 text-gradient-100',
          minor: 'bg-yellow-100 text-technology-geoThermal',
          other: 'bg-technology-nuclear/10 text-neutral-1000',
          success: 'bg-green-100 text-green-700',
          teal: 'border border-teal-300 bg-teal-100 text-teal-900',
          warning: 'bg-yellow-100 text-yellow-900',
        },
        size: {
          medium: 'label-100 px-3 py-[5px]',
          small: 'label-200 px-[10px] py-[3px]',
          'x-small': 'body-300-light px-[6px] py-px',
        },
      },
    });

    return (
      <span className={classNames(variants({ appearance, size }), className)} {...props} ref={ref}>
        {children}
      </span>
    );
  },
);
